import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import { reject } from "lodash";
import { ExamInfo } from "@/lib/model/exam/candidate";
import Auth from "@/lib/common/auth";
import _ from "lodash-es";
import { getDimensionColor } from "@/lib/dimension/dimension-color";
import EnumCandidate from "@/lib/enum/candidate";

export class JudgeCandidateForm extends Model {
  companyId = "";
  judgeId = 0;
  auditStatusList: number[] = [];
  examId = 0;
  submitStatusList: number[] = [];
  showNameOrPhone = "";
  judgeStatusList: number[] = [];
  ignoreLinkJudgeId = 0;
  sortKey = "";
  sortDict = "";

  page = 1;
  pageSize = 10;
}

export class JudgeCandidate extends Model {
  showName = "";
  phone = "";
  connectCode = "";
  candidateId = 0;
  scoreAi = 0;
  scoreJudge = 0;
  auditStatus = 0;
  submitTime = "";
  createdTime = "";
  examName = "";
  submitStatus = 0;
  judgeStatus = 0;

  getSubmitStatusName(): string {
    let statusText = "";
    switch (this.submitStatus) {
      case 0:
        statusText = "未登记";
        break;
      case 1:
        statusText = "答题中";
        break;
      case 2:
        statusText = "已交卷";
        break;
      case 3:
        statusText = "已登记";
        break;
    }
    return statusText;
  }
  getAuditStatusName(): string {
    const name = _.get(EnumCandidate.auditStatusListData, this.auditStatus);
    return name ? name : "未阅卷";
  }
  getJudgeStatusName(): string {
    return this.judgeStatus === 1 ? "已分配" : "未分配";
  }
}

export class HR extends Model {
  name = ""; // 面试官名称
  passwd = ""; // 密码
  encodeCandidateInfo = 2; // 是否加密候选人信息 012 冗余
  encodeTypeConnectCode = 0; // 0展示 1不展示 加密候选人编号
  encodeTypeBaseInfo = 0; // 0展示 1不展示 2加密展示 加密候选人基础信息
  encodeTypeOtherInfo = 0; // 0展示 1不展示  加密其他登记信息字段
  autoLinkSwitch = 2; //是否自动分配候选人
  autoLinkOldCandidate = 2; // 关联面试时 是否需要刷旧候选人数据 012
  linkExamIdList: string[] = []; // 自动分配关联面试id列表 空列表为手动分配
  linkExamNameList: string[] = [];
  judgeId = 0; // 面试官id
  judgeOutId = ""; // 面试官对外id
  companyId = ""; // 公司id
  count = 0; //候选人总数
  countAfterAudit = 0; //已评估总数
  examList: ExamInfo[] | null = [];
  showExamList = "";

  assign(data: any): any {
    this.linkExamNameList = [""];
    this.linkExamIdList = [""];
    const instance = super.assign(data);
    instance.showExamList = instance.linkExamNameList
      .filter(e => {
        return e;
      })
      .join("、");
    return instance;
  }

  public static login(params: any) {
    return request.post("aiExam/judgePublic/login", params).then(
      resp => {
        if (resp.data.code === 0) {
          return resp.data.data;
        }
      },
      err => {
        return false;
      }
    );
  }

  public getCandidateList(form: JudgeCandidateForm) {
    form.companyId = Auth.companyId;
    form.judgeId = this.judgeId;
    return request.post("/aiExam/judge/candidateList", form).then(resp => {
      if (resp.data.code === 0) {
        return resp.data.data;
      }
    });
  }

  public static createHR(params: any) {
    return request.post("aiExam/judge/create", params).then(resp => {
      if (resp.data.code === 0) {
        return resp.data.data;
      }
    });
  }

  public editHR() {
    const param = _.cloneDeep(this);
    param["companyId"] = Auth.companyId;
    return request.post("aiExam/judge/update", param).then(resp => {
      if (resp.data.code === 0) {
        return resp.data.data;
      }
    });
  }

  public deleteHr() {
    return request
      .post("/aiExam/judge/delete", {
        companyId: Auth.companyId,
        judgeId: this.judgeId
      })
      .then(resp => {
        if (resp.data.code === 0) {
          return resp.data.data;
        }
      });
  }

  public static multiLink(candidateIdList: any, judgeList: any): Promise<void> {
    return new Promise(function(resolve, reject) {
      request
        .post("/aiExam/judge/multiLink", {
          companyId: Auth.companyId,
          candidateIdList: candidateIdList,
          linkJudgeIdList: judgeList
        })
        .then(resp => {
          if (resp.data.code === 0) {
            resolve();
          } else reject();
        });
    });
  }

  public static multiLinkAll(judgeList: any, param: any): Promise<void> {
    return new Promise(function(resolve, reject) {
      request
        .post(
          "/aiExam/judge/multiLinkByQuery",
          Object.assign(
            {
              companyId: Auth.companyId,
              linkJudgeIdList: judgeList
            },
            param
          )
        )
        .then(resp => {
          if (resp.data.code === 0) {
            resolve();
          } else reject();
        });
    });
  }

  public static removeLink(
    candidateIdList: any,
    judgeList: any
  ): Promise<void> {
    return new Promise(function(resolve, reject) {
      request
        .post("/aiExam/judge/multiLink", {
          companyId: Auth.companyId,
          candidateIdList: candidateIdList,
          unLinkJudgeIdList: judgeList
        })
        .then(resp => {
          if (resp.data.code === 0) {
            resolve();
          } else reject();
        });
    });
  }

  public static moveLink(
    candidateIdList: any,
    unLinkJudgeIdList: any,
    linkJudgeIdList: any
  ): Promise<void> {
    return new Promise(function(resolve, reject) {
      request
        .post("/aiExam/judge/multiLink", {
          companyId: Auth.companyId,
          candidateIdList: candidateIdList,
          unLinkJudgeIdList: unLinkJudgeIdList,
          linkJudgeIdList: linkJudgeIdList
        })
        .then(resp => {
          if (resp.data.code === 0) {
            resolve();
          } else reject();
        });
    });
  }

  public static moveLinkAll(
    unLinkJudgeIdList: any,
    linkJudgeIdList: any,
    param: any
  ): Promise<void> {
    return new Promise(function(resolve, reject) {
      request
        .post(
          "/aiExam/judge/multiLinkByQuery",
          Object.assign(
            {
              companyId: Auth.companyId,
              unLinkJudgeIdList: unLinkJudgeIdList,
              linkJudgeIdList: linkJudgeIdList
            },
            param
          )
        )
        .then(resp => {
          if (resp.data.code === 0) {
            resolve();
          } else reject();
        });
    });
  }
}
export class HRList extends Model {
  list: HR[] = [new HR()];
  count = 0;
  public static getList(params: any) {
    return request.post("aiExam/judge/list", params).then(resp => {
      if (resp.data.code === 0) {
        return new HRList().assign(resp.data.data);
      }
    });
  }

  public static getListAll(params: any) {
    return request.post("aiExam/judge/allJudgeList", params).then(resp => {
      if (resp.data.code === 0) {
        return new HRList().assign(resp.data.data);
      }
    });
  }
}
